import { useTranslation } from 'react-i18next';
import { Namespace } from '@data/index';
import { AntdEmpty } from '@ui/components';

export const TrialsEmptyState = () => {
  const { t } = useTranslation([Namespace.ADMIN]);

  return <AntdEmpty className="mt-10" description={t('trials_library.empty.description')} />;
};
